// removed by extract-text-webpack-plugin
module.exports = {"gridItem":"general__gridItem___33eeJ boxSizing-borderBox listStyle-none"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/GridItem/style/general.css
// module id = 40
// module chunks = 0 1 6